import script from "./IconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconButton.vue?vue&type=script&lang=ts&setup=true"

import "./IconButton.vue?vue&type=style&index=0&id=3aea6c04&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aea6c04"]])

export default __exports__